import { useContext, useMemo } from "react";
import { ProjectContext } from "context/ProjectProvider";
import { isProjectInIntegrationMode } from "utils/utils";
import { useGetProjectINTGState } from "hooks/submittal";
import {
  getSubmittalIntegrationConfig,
  isSubmittalIntegrationMode
} from "pages/subscription-settings/integrations-tab-new/utils";

const useSubmittalIntegration = (options?: { skip?: boolean }) => {
  const skip = options?.skip ?? false;
  const {
    projectDetails,
    projectIntegrationConfig,
    isProcoreProject,
    gqlClientForProject
  } = useContext(ProjectContext);

  // An OPC-only project is in integration mode for its schedule while its
  // submittals stay manual — see isSubmittalIntegrationMode.
  const isIntegrationMode = isSubmittalIntegrationMode(
    isProjectInIntegrationMode(projectDetails ? projectDetails.mode : 0),
    projectIntegrationConfig
  );

  const { isIntegrationConfigured } = useGetProjectINTGState({
    client: gqlClientForProject,
    skip: skip || !isIntegrationMode
  });

  const currentSourceType = useMemo(() => {
    // Not [0] — see getSubmittalIntegrationConfig. This names the system the
    // submittals came from, so a schedule-only OPC config is never the answer
    // even when it happens to sort first.
    return (
      getSubmittalIntegrationConfig(projectIntegrationConfig)?.integration
        ?.system ?? ""
    );
  }, [projectIntegrationConfig]);

  return {
    isIntegrationMode,
    projectIntegrationConfig,
    isIntegrationConfigured,
    isProcoreProject,
    currentSourceType
  };
};

export default useSubmittalIntegration;
